<template>
  <el-container class="list" style="display:block;">
		<el-container style="display:block;" class="test">
			请输入数据库中已经存在数据相关的测试语句进行测试 
		</el-container> 
		<el-row class="s-list lel">			 
			 
			<el-col :span="6" class="l-search"><input type="text" v-model="name"/></el-col>
			<el-col :span="1" class="l-searched" @click.native="loadData()">测试</el-col>
		</el-row>		 
		<el-container style="display:block;" class="c-list" v-if="type == 1">
			<el-row class="c-list-title lel">
				{{name1}}测试结果如下
			</el-row>
			<el-row class="c-list-content lel">
				<el-col :span="9">					 
					<el-col :span="8"><img class="img-content" v-bind:src="list.img_01"/></el-col>
					<el-col :span="14" class="bl">
						<el-row class="cl">【Hi兔】{{list.describe}}</el-row>
						 
					</el-col>
				</el-col>
				<el-col :span="11" class="cl">{{list.lable}}</el-col>				 
				<el-col :span="2" class="al">{{list.user_name}}</el-col>				 
				<el-col :span="2" class="al">{{list.add_time}}</el-col>
			</el-row>
		</el-container>
		<el-container style="display:block;" class="c-list" v-if="type == 0">
			结果未查询到,已将{{name1}}记录数据库 
		</el-container> 
		
  </el-container>
</template>

<script>
	
  export default {
    data() {
      return {
		 
        list:'',		 
		userId:window.localStorage.getItem('id'),
		type:2, 
		name:'',
		name1:'',
		url:this.$store.getters.getUrl
      };
    },
    created() {
	//	var cip = returnCitySN["cip"];
// 		if(this.$store.getters.getRole != 'admins'){
// 				   if(cip !='117.9.19.251' && cip !='60.27.105.250' && cip !='60.27.106.235'){
// 					   this.$router.push({ path: '/' }) 
// 				   }
// 		}
if(!window.localStorage.getItem('id')){
      this.$router.push({ path: '/' })
    }
		var lett = this;
		document.onkeydown = function(e) {
			var key = window.event.keyCode;
			if (key == 13) {
				lett.loadData();
			}
		}
	}, 
		methods:{
			 
			 
			loadData(){
				this.name1 = this.name;
				if(this.name.trim() == ''){
					this.$message({
					  message: '请输入内容',
					  type: 'error'
					});
					return false;
				}
				const axiosInstance = this.$axios.create({
					headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
					withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
				});
				 
				axiosInstance({
					method:'post',
					url:'http://fencip.yoooooo.com/index.php/index/data/Tests',
					params:{						 
						content:this.name,
						userId:this.userId,
					} 
				})
				.then(res=>{
					 
					this.list = res.data.data;					 
					this.type = res.data.type;
					this.name = '';
				})
				.catch(err=>{
					
				});
			},
			 
			 
			
		} 
			
	 
  }
</script>

<style>
	 
	 
	.list{
		margin-left: 15%;
		margin-right: 15%;
	}
	 
	.s-list{
		margin-bottom: 30px;
		margin-top: 30px;
		
	}
	.l-search{
		margin-left: 150px;
		 
		text-align: left;
	}
	.l-search input{
		height: 30px;
		width: 320px;
	}
	.l-searched{
		background: orange;
		color: #fff;
		height: 35px;
		line-height: 35px;
		margin-left: 10px;
	}
	 
	.c-list-title{
		border: 1px solid #a0a0a0;
		background: #eeeeee;
		height: 50px;
		line-height: 50px;
	}
	.c-list-title .el-col{
		text-align: center;
	}
	.c-list-content{
		height: 150px;
		border-bottom: 1px solid #939AA0;
	}
	.img-content{
		margin-top: 10px;
	}
	.lel{
		text-align: center;
	}
	.img-content{
		width: 120px;
		height: 120px;
	}
	.al{
		margin-top: 55px;
	}
	.cl{
		margin-top: 40px;
	}
	.bl{
		margin-top: 30px;
	}
	.bl .el-row{
		margin-bottom: 5px;		
	}
	.bl .lel{
		color: blue;
	}
	.test{
		margin-left: 150px; 
		margin-top: 100px;
	} 
</style>



// WEBPACK FOOTER //
// src/components/main/test.vue